import { useAuthTheme } from '@euler/app/flows/auth/hooks';
import AppleLogo from '@euler/assets/apple-logo-black.svg';
import { Icon } from '@euler/components/Icomoon';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo, ReactNode } from 'react';
import {
  Platform,
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import styled from 'styled-components/native';

const kIconSize = 24;
const kIconSpace = 12;

const Line = styled.View`
  height: 1px;
  flex: 1;
`;

const IconWrap = memo(
  ({
    style,
    children,
    onPress,
  }: {
    children?: ReactNode;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const theme = useAuthTheme();
    const size = rpx(kIconSize + kIconSpace);
    return (
      <TouchableOpacity
        css={`
          width: ${size}px;
          height: ${size}px;
          border-radius: ${size}px;
          background-color: ${theme.loginMethods.iconBgColor};
          align-items: center;
          justify-content: center;
          margin: 0 ${rpx(10)}px;
          overflow: hidden;
        `}
        style={style}
        onPress={onPress}
      >
        {children}
      </TouchableOpacity>
    );
  },
);

export const LoginMethods: FC<{
  style?: StyleProp<ViewStyle>;
  enableWechatLogin?: boolean;
  enableAppleLogin?: boolean;
  onLoginPhone?: () => void;
  onLoginWechat?: () => void;
  onLoginApple?: () => void;
}> = memo(
  ({
    style,
    enableWechatLogin,
    enableAppleLogin,
    onLoginPhone,
    onLoginWechat,
    onLoginApple,
  }) => {
    const theme = useAuthTheme();
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          align-items: center;
        `}
        style={style}
      >
        <View
          css={`
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 0 ${rpx(16)}px;
          `}
        >
          <Line
            css={`
              background-color: ${theme.loginMethods.separatorLineColor};
            `}
          />
          <Text
            css={`
              margin: 0 ${rpx(12)}px;
              color: ${theme.loginMethods.titleTextColor};
              font-family: ${FontFamily.NotoSans.Light};
              font-weight: 300;
              font-size: ${rpx(12)}px;
            `}
          >
            使用其他方式登录
          </Text>
          <Line
            css={`
              background-color: ${theme.loginMethods.separatorLineColor};
            `}
          />
        </View>
        <View
          css={`
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-top: ${rpx(12)}px;
          `}
        >
          <IconWrap onPress={onLoginPhone}>
            <Icon
              name="mobile"
              size={rpx(kIconSize) * 0.8}
              color={theme.loginMethods.iconColor}
            />
          </IconWrap>
          {enableWechatLogin && (
            <IconWrap onPress={onLoginWechat}>
              <Icon name="wechat" size={rpx(kIconSize)} color="#1AAD19" />
            </IconWrap>
          )}
          {Platform.OS === 'ios' && enableAppleLogin && (
            <IconWrap onPress={onLoginApple}>
              <AppleLogo />
            </IconWrap>
          )}
        </View>
      </View>
    );
  },
);
